import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Paper,
  Typography,
  Button,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import FormErrorDialog from '../../common/components/formErrorDialog';
import Alert from '../../common/components/Alert';
import * as profileActions from '../actions';
import * as constants from '../../config/constants';
import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

import AccountInfoForm from '../components/AccountInfoForm';
import PersonalInfoForm from '../components/PersonalInfoForm';
import LifestyleInfoForm from '../components/LifestyleInfoForm';
import EducationInfoForm from '../components/EducationInfoForm';
import FamilyInfoForm from '../components/FamilyInfoForm';
import ContactInfoForm from '../components/ContactInfoForm';
import ReferenceInfoForm from '../components/ReferenceInfoForm';
import FileUploadForm from '../components/FileUploadForm';
import PartnerChoiceForm from '../components/PartnerChoiceForm';


class EditProfile extends Component {
  componentDidMount() {
    const section = this.props.match.params.section;  // eslint-disable-line
    this.props.getSectionData(
      section,
      this.props.token,
      this.props[section],
      this.props.history,
      this.props.siteId,
      true,
    );
    document.title = constants.SECTION_TITLES[section];
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  getForm = () => {
    switch (this.props.match.params.section) {
      case 'basicinfo':
        return (
          <AccountInfoForm
            inputs={this.props.basicinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'personalinfo':
        return (
          <PersonalInfoForm
            inputs={this.props.personalinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'lifestyleinfo':
        return (
          <LifestyleInfoForm
            inputs={this.props.lifestyleinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'educationinfo':
        return (
          <EducationInfoForm
            inputs={this.props.educationinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'familyinfo':
        return (
          <FamilyInfoForm
            inputs={this.props.familyinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'contactinfo':
        return (
          <ContactInfoForm
            inputs={this.props.contactinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'referenceinfo':
        return (
          <ReferenceInfoForm
            inputs={this.props.referenceinfo}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      case 'photos':
        return (
          <FileUploadForm
            inputs={this.props.photos}
            inputChangedHandler={this.inputChangedHandler}
            files={this.props.files}
            deleteFile={fileID => this.deleteFile(fileID)}
            setAvatar={this.setAvatar}
            errors={this.props.errors}
            fileType="IMAGE"
            editMode
          />
        );
      case 'pdfs':
        return (
          <FileUploadForm
            inputs={this.props.pdfs}
            inputChangedHandler={this.inputChangedHandler}
            files={this.props.files}
            deleteFile={fileID => this.deleteFile(fileID)}
            errors={this.props.errors}
            editMode
          />
        );
      case 'partnerchoice':
        return (
          <PartnerChoiceForm
            inputs={this.props.partnerchoice}
            inputChangedHandler={this.inputChangedHandler}
            editMode
          />
        );
      default:
        return null;
    }
  }

  inputChangedHandler = (event, field) => {
    const section = this.props.match.params.section;  // eslint-disable-line
    this.props.inputChangedHandler(
      event,
      field,
      section,
      this.props[section],
    );
  }

  submitHandler = (event) => {
    const section = this.props.match.params.section;  // eslint-disable-line
    this.props.submitHandler(
      event,
      section,
      this.props[section],
      this.props.token,
      this.props.history,
      this.props.siteId,
      true,
    );
  }

  deleteFile = (fileID) => {
    this.props.deleteFile(fileID, this.props.token, true);
  }

  setAvatar = (fileID) => {
    this.props.setAvatar(fileID, this.props.token);
  }

  backToProfile = () => {
    this.props.history.replace(
      formatRoute(
        routes.VIEW_PROFILE,
        { uuid: this.props.user.slug },
      ),
    );
  }

  render() {
    const title = constants.SECTION_TITLES[this.props.match.params.section];

    let loading = null;
    if (this.props.loading) {
      loading = (
        <div align="center">
          <br /><br /><br />
          <CircularProgress align="center" size={50} />
          <br />
          <Typography variant="subheading">Please wait. This may take some time! <br /> Please do not refresh the page.</Typography>
        </div>
      );
    }

    let success = null;
    if (this.props.success) {
      success = (
        <Alert type="success">
          {this.props.success}
        </Alert>
      );
    }

    let errors = null;
    if (this.props.errors.length > 0) {
      errors = (
        <Alert type="danger">
          {this.props.errors}
        </Alert>
      );
    }

    let display = null;

    if (!this.props.loading) {
      display = (
        <Paper className={[classes.padding20, classes.noBorderXS].join(' ')}>
          <Button onClick={this.backToProfile} variant="outlined" color="default"><PrevIcon />Back</Button> <br /><br />
          {success}
          {errors}
          <Typography variant="headline" className={classes.regTitle}>{title}</Typography>
          <span className={classes.titleUnderline} />
          <form method="post" onSubmit={this.submitHandler} encType="multipart/form-data">
            {this.getForm()}
          </form>
          <br />
        </Paper>
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="home"
        dashActiveLink="profile"
        user={this.props.user}
      >
        {loading}
        {display}
        <FormErrorDialog open={this.props.hasError} handleClose={this.props.toggleError} />
      </DashboardLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.profile.loading,
    hasError: state.profile.hasError,
    files: state.profile.files,
    errors: state.profile.errors,
    success: state.profile.success,
    basicinfo: state.profile.basicinfo,
    personalinfo: state.profile.personalinfo,
    lifestyleinfo: state.profile.lifestyleinfo,
    educationinfo: state.profile.educationinfo,
    familyinfo: state.profile.familyinfo,
    contactinfo: state.profile.contactinfo,
    referenceinfo: state.profile.referenceinfo,
    photos: state.profile.photos,
    pdfs: state.profile.pdfs,
    partnerchoice: state.profile.partnerchoice,
    siteId: state.common.site.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSectionData: (section, token, inputs, history, siteId, editMode) => dispatch(
      profileActions.getSectionData(section, token, inputs, history, siteId, editMode),
    ),
    toggleError: () => dispatch(profileActions.toggleError()),
    inputChangedHandler: (event, field, section, inputs) => dispatch(
      profileActions.inputChangedHandler(event, field, section, inputs),
    ),
    submitHandler: (event, section, inputs, token, history, siteId, editMode) => dispatch(
      profileActions.submitHandler(event, section, inputs, token, history, siteId, editMode),
    ),
    deleteFile: (fileID, token, editMode) => dispatch(
      profileActions.deleteFile(fileID, token, editMode),
    ),
    setAvatar: (fileID, token) => dispatch(
      profileActions.setAvatar(fileID, token),
    ),
    onUnmount: () => dispatch(profileActions.onUnmount()),
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditProfile));



// WEBPACK FOOTER //
// ./src/profile/containers/EditProfile.js